export const isBrowser = typeof window !== 'undefined';

export function getEnv(name: string, fallback?: string): string | undefined {
  if (isBrowser) {
    return (import.meta as any).env?.[name] ?? fallback;
  }

  // eslint-disable-next-line no-undef
  return (process as any)?.env?.[name] ?? fallback;
}
